import React, { createContext, useState, useEffect, useCallback } from 'react';

export const CookieConsentContext = createContext();

const CONSENT_STORAGE_KEY = 'brainybees-cookie-consent';

export const CookieConsentProvider = ({ children }) => {
  const [consent, setConsent] = useState(null); // null: undecided, true: accepted, false: declined

  useEffect(() => {
    const savedConsent = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (savedConsent !== null) {
      setConsent(JSON.parse(savedConsent));
    }
  }, []);

  const updateGtagConsent = (hasConsent) => {
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        'analytics_storage': hasConsent ? 'granted' : 'denied'
      });
    }
  };

  const acceptCookies = useCallback(() => {
    console.log("Cookies accepted by user.");
    window.localStorage.setItem(CONSENT_STORAGE_KEY, 'true');
    setConsent(true);
    updateGtagConsent(true);
  }, []);

  const declineCookies = useCallback(() => {
    console.log("Cookies declined by user.");
    window.localStorage.setItem(CONSENT_STORAGE_KEY, 'false');
    setConsent(false);
    updateGtagConsent(false);
  }, []);

  return (
    <CookieConsentContext.Provider value={{ consent, acceptCookies, declineCookies }}>
      {children}
    </CookieConsentContext.Provider>
  );
};